import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ReferralModalComponent } from '../referral-modal/referral-modal.component';
import { SelectNewReferralUserTypeModalComponent } from '../select-new-referral-user-type-modal/select-new-referral-user-type-modal.component';
import { AuthService } from 'core';
import { UserTypes } from 'shared/types/user.model';

@Injectable({
  providedIn: 'root'
})
export class ReferralModalFacade {
  public referralDetailReloadSubject: Subject<void> = new Subject<void>();

  constructor(
    private _authService: AuthService,
    private _modalService: NzModalService
  ) {}

  public openAddReferralModal(): void {
    const specialUsers = [UserTypes.PR];
    const currentUserType = this._authService?.currentUser?.userType;
    const currentUserIsSpecial = specialUsers.includes(currentUserType);

    currentUserIsSpecial
      ? this._openSelectNewReferralUserTypeModal()
      : this.openAddNewReferralFormModal({ userType: UserTypes.SD });
  }

  private _openSelectNewReferralUserTypeModal(): void {
    this._modalService.create({
      nzContent: SelectNewReferralUserTypeModalComponent,
      nzWidth: 608,
      nzWrapClassName: 'modal-wrap',
      nzClassName: 'modal-dialog'
    });
  }

  public openAddNewReferralFormModal(modalData?: any): void {
    this._modalService.create({
      nzContent: ReferralModalComponent,
      nzWidth: 555,
      nzWrapClassName: 'modal-wrap',
      nzClassName: 'modal-dialog',
      nzData: modalData
    });
  }
}
